import { images } from "../../../Assets/assetsHelper";
import "./ClassesDetails.css";
import React, { useState } from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import { MoonLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import SchoolIcon from "@mui/icons-material/School";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BusinessIcon from "@mui/icons-material/Business";
import CloseIcon from "@mui/icons-material/Close";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PersonIcon from "@mui/icons-material/Person";
import ClassIcon from "@mui/icons-material/Class";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { BaseURL } from "../../../Hooks/URL";
import StudentCard from "../../../Components/Molecules/Cards/StudentCard/StudentCard";

function ClassesDetails({
  role,
  Class,
  setClass,
  url,
  setGo,
  loading,
  students,
  studentsLoading,
  StudentsOpen,
  setStudentsOpen,
  studentUrl,
  setGoSave,
  TerminateLoading,
  setStudents,
  reports,
}) {
  const navigate = useNavigate();

  const monthsList = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }
  return (
    <div className="mainContainer">
      {Class && (
        <>
          {/* Action Buttons */}
          <div className="courseActions">
            <button
              className="actionButton primary"
              onClick={() => navigate(`/classes/${Class?.id}/sessions`)}
            >
              Sessions
            </button>
            {!Class?.isTerminated && (role == "admin" || role == "school") && (
              <button
                className="actionButton primary"
                onClick={() => navigate(`/classes/add/${Class?.id}`)}
              >
                Edit Class
              </button>
            )}
            {!Class?.isTerminated && (role == "admin" || role == "school") && (
              <DeleteForm
                classes={"actionButton secondary"}
                buttonText={
                  <>
                    {TerminateLoading ? (
                      <MoonLoader color="#012369" size={8} />
                    ) : null}
                    Terminate Class
                  </>
                }
                setGo={setGoSave}
                title={"Are you sure to terminate this class?"}
              />
            )}
            {(role == "admin" || role == "school") && (
              <DeleteForm
                setGo={setGo}
                title={"Are you sure to delete this class?"}
              />
            )}
          </div>

          {/* Class Header Section */}
          <div className="contentSection">
            <div className="courseHeader">
              <div className="courseIconSection">
                <div className="titleIcon">
                  <MenuBookIcon />
                </div>
              </div>
              <div className="courseBasicInfo">
                <h1 className="courseName">{Class.className}</h1>
              </div>
              <div className="courseStats">
                <div
                  className="statItem clickable"
                  onClick={() => {
                    const studentsSection = document.getElementById("students");
                    studentsSection?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <PersonIcon className="statIcon" />
                  <span className="statLabel">Students</span>
                  <span className="statValue">{students?.length || 0}</span>
                </div>
                <div
                  className="statItem clickable"
                  onClick={() => {
                    const feedbacksSection =
                      document.getElementById("feedbacks");
                    feedbacksSection?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <AssessmentIcon className="statIcon" />
                  <span className="statLabel">Feedbacks</span>
                  <span className="statValue">{reports?.length || 0}</span>
                </div>
                <div className="statItem">
                  <SchoolIcon className="statIcon" />
                  <span className="statLabel">Status</span>
                  <span className="statValue">
                    {Class?.isTerminated ? "Terminated" : "Active"}
                  </span>
                </div>
              </div>
            </div>

            <h2 className="sectionTitle">Class Details</h2>
            <div className="infoGrid">
              <div
                className="infoItem clickable"
                onClick={() => navigate(`/programs/${Class?.course?.id}`)}
              >
                <div className="infoLabel">
                  <SchoolIcon className="infoIcon" />
                  Program
                </div>
                <div className="infoValue">
                  {Class?.course?.title || "No program assigned"}
                </div>
              </div>
              <div
                className="infoItem clickable"
                onClick={() => {
                  if (role == "admin" || role == "school")
                    navigate(`/schools/${Class?.school?.id}`);
                }}
              >
                <div className="infoLabel">
                  <BusinessIcon className="infoIcon" />
                  School
                </div>
                <div className="infoValue">
                  {Class?.school?.name || "No school assigned"}
                </div>
              </div>
              <div
                className="infoItem clickable"
                onClick={() => {
                  if (role == "admin" || role == "school")
                    navigate(`/instructors/${Class?.teacher?.id}`);
                }}
              >
                <div className="infoLabel">
                  <PersonIcon className="infoIcon" />
                  Instructor
                </div>
                <div className="infoValue">
                  {Class?.teacher?.name || "No instructor assigned"}
                </div>
              </div>
            </div>
          </div>

          <div className="contentSection" id="feedbacks">
            <div className="lessonsHeader">
              <h2 className="sectionTitle">Class Feedbacks</h2>
              {!Class?.isTerminated && (
                <button
                  className="actionButton primary"
                  onClick={() => navigate(`/classes/${Class?.id}/reports/add`)}
                >
                  <AddIcon />
                  Add Feedback
                </button>
              )}
            </div>

            {reports?.length ? (
              <div className="lessonsGrid">
                {reports?.map((report, index) => (
                  <div
                    key={report.id}
                    className="courseCard"
                    onClick={() =>
                      navigate(`/classes/${Class?.id}/reports/${report.id}`)
                    }
                  >
                    <div
                      className="courseHeader"
                      style={{ marginBottom: "20px" }}
                    >
                      <div className="courseIcon">
                        <AssessmentIcon />
                      </div>
                      <h3 className="courseTitle">
                        Feedback{" "}
                        {
                          monthsList.find((month) => month.id === report?.month)
                            ?.name
                        }
                      </h3>
                    </div>

                    <div className="courseContent">
                      <button
                        className="actionButton primary"
                        style={{ width: "fit-content", margin: "0 auto" }}
                      >
                        view all feedbacks
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <AssessmentIcon className="emptyIcon" />
                <h3>No Feedbacks</h3>
                <p>There are no feedbacks for this class</p>
                <button
                  className="actionButton primary"
                  onClick={() => navigate(`/classes/${Class?.id}/reports/add`)}
                  style={{ margin: "20px auto" }}
                >
                  <AddIcon />
                  Add Feedback
                </button>
              </div>
            )}
          </div>

          {/* Students Section */}
          <div className="contentSection" id="students">
            <div className="lessonsHeader">
              <h2 className="sectionTitle">Enrolled Students</h2>
              {!Class?.isTerminated && (role == "admin" || role == "school") ? (
                <button
                  className="actionButton primary"
                  onClick={() => navigate(`/classes/${Class?.id}/enroll`)}
                >
                  <AddIcon />
                  Add Student
                </button>
              ) : null}
            </div>

            {studentsLoading ? (
              <div className="loadingContainer">
                <MoonLoader color="#012369" size={40} />
              </div>
            ) : (
              <>
                {students && students.length > 0 ? (
                  <>
                    {students && students.length > 0 ? (
                      <div className="studentsGridClass">
                        {students?.map((student) => (
                          <StudentCard
                            role={role}
                            feedback={false}
                            key={student?.id}
                            student={student}
                            isTerminated={Class?.isTerminated}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="emptyState">
                        <PersonIcon className="emptyIcon" />
                        <h3>No Students Enrolled</h3>
                        <p>This class doesn't have any students yet.</p>
                        {!Class?.isTerminated && (
                          <button
                            className="actionButton primary"
                            onClick={() =>
                              navigate(`/classes/${Class?.id}/enroll`)
                            }
                            style={{ margin: "20px auto" }}
                          >
                            <AddIcon />
                            Add First Student
                          </button>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="emptyState">
                    <PersonIcon className="emptyIcon" />
                    <h3>No Students Enrolled</h3>
                    <p>This class doesn't have any students yet.</p>
                    {!Class?.isTerminated && (
                      <button
                        className="actionButton primary"
                        onClick={() => navigate(`/classes/${Class?.id}/enroll`)}
                        style={{ margin: "20px auto" }}
                      >
                        <AddIcon />
                        Add First Student
                      </button>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default ClassesDetails;
